export const mfaReminderTypes = {
    MFA_USER_HARD_REMINDER: 'MFA_USER_HARD_REMINDER',
    MFA_USER_SOFT_REMINDER: 'MFA_USER_SOFT_REMINDER',
    MFA_COMPANY_REMINDER: 'MFA_COMPANY_REMINDER',
};

export const MFA_LAUNCH_DATE = '2023-05-29T00:00:00.000Z';
